
import { ReactComponent as LoadingIcon } from 'assets/icons/refresh.svg'
import { useTranslation } from "react-i18next"
import useLayout from "hooks/useLayout"
import useAuth from "hooks/useAuth"
import Avatar from './Avatar'
import { FormStatus } from 'types'

interface UserAvatarProps {
    showName?: boolean
}

const UserAvatar: React.FC<UserAvatarProps> = ({ showName }) => {

    const { t } = useTranslation()

    // Auth hooks.
    const { accountPublicData, isLoadingAccountPublicData } = useAuth()
    const name = accountPublicData?.name
    const hasAvatar = !!accountPublicData?.other?.avatarUrl
    const avatarUrl = accountPublicData?.other?.avatarUrl
    const avatarColor = accountPublicData?.other?.avatarColor
    const loadAccountDataStatus = isLoadingAccountPublicData ? FormStatus.LOADING : FormStatus.IDLE

    return (
        <>
            {
                loadAccountDataStatus === FormStatus.LOADING ?
                <LoadingIcon className="animate-spin w-6 h-6 fill-current text-black" /> :
                <div className="relative select-none">
                    <div className="flex flex-col gap-y-2 items-center">
                        <Avatar
                            avatarUrl={avatarUrl}
                            name={accountPublicData?.other?.isComplete ? name : undefined}
                            hasAvatar={hasAvatar}
                            size="xxl"
                            avatarColor={avatarColor}
                        />
                        {showName && <h1>{t(`helloUsername`, {name})}</h1>}
                    </div>
                </div>
            }
        </>
    )
}

export default UserAvatar

